.root {
  composes: page from './utils.module.css';
}

.root section {
  max-width: 45em;
}

.root section + section {
  padding-top: 2rem;
}

.root h2 {
  margin-top: 0;
  margin-bottom: 0.75rem;
  color: hsl(240, 6%, 15%);
  font-family: var(--font-logo);
  font-weight: normal;
  letter-spacing: 0.03em;
}

.root h2 > span {
  color: var(--color-five);
  filter: invert();
}

.root p,
.root ul {
  margin-top: 0;
}

.url {
  display: block;
  font-size: 90%;
  max-width: max-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-style: italic;
}

.listSpaced > li + li {
  margin-top: 0.75rem;
}

.listSpaced {
  margin-bottom: 1.5rem;
}

@media (min-width: 90em) {
  .url {
    overflow: visible;
  }
}
